<template>
  <Form ref="details" label-position="right" :label-width="120" style="width: 730px">
    <Row span="24">
      <Col span="10">
      <FormItem :label="$t('status.state.640567-0')">
        <Input :value="data.UserDeviceName" disabled> </Input>
      </FormItem>
      </Col>
      <Col span="10">
      <FormItem :label="$t('status.state.640567-1')">
        <Input :value="data.IsOnline ? $t('status.state.640567-2') : $t('status.state.640567-3')" disabled> </Input>
      </FormItem>
      </Col>
      <Col span="10">
      <FormItem :label="$t('status.state.640567-4')">
        <Input :value="data.Address" disabled> </Input>
      </FormItem>
      </Col>
      <Col span="10">
      <FormItem :label="$t('status.state.640567-5')">
        <Input :value="data.ContactsPhone || $t('status.state.640567-6')" disabled> </Input>
      </FormItem>
      </Col>
      <Col span="10" v-for="(item, index) in fromDatas" :key="index">
      <FormItem :label="item.ParamName">
        <Input :value="item.ParamValue" disabled>
        <span slot="append" v-if="item.ParamUnit">{{
          item.ParamUnit
        }}</span>
        </Input>
      </FormItem>
      </Col>
    </Row>
  </Form>
</template>

<script>
import api from "../../../../../../api/request.js";
import Cookies from "js-cookie";
const URL = {
  DeviceParameterLook: "api/YhjDevice/DeviceParameterLook"
};

export default {
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      loading: true,
      fromDatas: [],
    };
  },
  mounted() {
    this.DeviceParameterLook(this.data.DeviceCode);
  },
  computed: {
    shows: {
      get() {
        return this.show;
      },
      set(newValue) {
        this.$emit("update:show", newValue);
      },
    },
  },
  methods: {
    // 获取设备状态（yhj）
    DeviceParameterLook(DeviceCode) {
      let _this = this;
      api(
        {
          //这里是你自己的请求方式、url和data参数
          method: "post",
          url: URL.DeviceParameterLook,
          data: {
            DeviceCode,
          },
          //假设后台需要的是表单数据这里你就可以更改
          headers: {
            "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
            Authorization: Cookies.get("Token"),
          },
        },
        "yhj"
      ).then((res) => {
        if (res.Success) {
          this.fromDatas = res.Data || [];
        } else {
          _this.DeviceParameterLookLists = [];
          _this.$Message["error"]({
            background: true,
            content: res.Message,
          });
        }
      });
    },
  },
};
</script>

<style scoped="scoped">
.area-text {
  cursor: pointer;
}

.vacancy {
  width: 100%;
  height: 300px;
  text-align: center;
  line-height: 300px;
}
</style>


// WEBPACK FOOTER //
// src/components/useGas/views/device/mods/status/state.vue